/*
 * Copyright (C) 2024 Viasat, Inc.
 * All rights reserved.
 * The information in this software is subject to change without notice and
 * should not be construed as a commitment by Viasat, Inc.
 *
 * Viasat Proprietary
 * The Proprietary Information provided herein is proprietary to Viasat and
 * must be protected from further distribution and use. Disclosure to others,
 * use or copying without express written authorization of Viasat, is strictly
 * prohibited.
 */

import { Route, Switch, useRouteMatch } from "react-router-dom";
import { Box } from "@mui/material";
import HnaRequestsTable from "./HnaRequestsTable";
import HnaRequestsForm from "./HnaRequestsForm";
import HnaRequestView from "./HnaRequestView";

const HnaRequests = () => {
  const { path } = useRouteMatch();

  return (
    <Box display="flex" flexDirection="column" height={'100%'} gap={'8px'}>
      <Switch>
        <Route path={path} exact>
          <HnaRequestsTable/>
        </Route>

        <Route path={`${path}/new`}>
          <HnaRequestsForm />
        </Route>

        <Route path={`${path}/view/:uuid`}>
          <HnaRequestView />
        </Route>

        <Route path={`${path}/review/:uuid`}>
          <HnaRequestView />
        </Route>

        <Route path={`${path}/edit/:uuid`}>
          <HnaRequestsForm />
        </Route>
      </Switch>
    </Box>
  );
};

export default HnaRequests;
